import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {EMPTY, Observable} from 'rxjs';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {switchMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SelectiveSsoInterceptorService implements HttpInterceptor {

  constructor(private oidcSecurityService: OidcSecurityService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.includes('/api/User/Profile')) {
      return next.handle(request);
    }

    return this.oidcSecurityService.getAccessToken().pipe(
      switchMap(accessToken => {
        const headers = request.headers
          .set('Authorization-Access', `Bearer ${accessToken || ''}`);

        return this.oidcSecurityService.getIdToken().pipe(
          switchMap(idToken => {
            const updatedHeaders = headers.set('Authorization', `Bearer ${idToken || ''}`);
            const updatedRequest = request.clone({ headers: updatedHeaders });

            if (accessToken !== '' && idToken !== '') {
              return next.handle(updatedRequest);
            } else {
              return EMPTY;
            }
          })
        );
      })
    );
  }
}
